import * as React from "react";
import { cn } from "../../lib/utils";

interface ResponsiveTableContainerProps {
  children: React.ReactNode;
  className?: string;
  maxHeight?: string;
}

const ResponsiveTableContainer = React.forwardRef<
  HTMLDivElement,
  ResponsiveTableContainerProps
>(({ children, className, maxHeight = "none", ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "responsive-table-container w-full overflow-hidden rounded-lg border border-border bg-card",
      className
    )}
    {...props}
  >
    <div
      className="responsive-table-scroll overflow-x-auto"
      style={{ maxHeight }}
    >
      {children}
    </div>
  </div>
));
ResponsiveTableContainer.displayName = "ResponsiveTableContainer";

export { ResponsiveTableContainer };